import { PageSectionsHorizontalCtaBanner } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { Action, ActionButtons } from './Buttons/ActionButtons';
import { PageSection } from './PageSection';
export interface HorizontalCtaBannerProps {
  data: PageSectionsHorizontalCtaBanner;
}
export function HorizontalCtaBanner({
  data,
  ...props
}: HorizontalCtaBannerProps) {
  return data ? <PageSection bgVariant="callout" {...props}>
      <div className="x78zum5 x1a02dak x1mhrlx8 x6s0dn4 x1qughib">
        <h1 {...stylex.props([typography.heading3, localStyles.ctaHeading])} data-tina-field={tinaField(data, 'text')}>
          {data?.text}
        </h1>
        <div className="x1en00fv xrvj5dj x54v5cx x16pmaob">
          {data?.actions && <ActionButtons actions={data.actions as Action[]} args={{
          componentName: data.__typename
        }} />}
        </div>
      </div>
    </PageSection> : null;
}
const localStyles = {
  ctaHeading: {
    kN2L0X: "x1w2vvpw",
    k7Eaqz: "x1gzrp8p",
    kUk6DE: "x98rzlu",
    $$css: true
  }
};